
import { createSlice } from '@reduxjs/toolkit';
import { ToastData } from '@/utils/types';

const initialState = {
	data: {
		detail: 'error',
		severity: 'error',
		summary: 'Error',
	},
	show: false,
};

const toastSlice = createSlice({
	name: 'toastSlice',
	initialState,
	reducers: {
		showToast(state, action: { payload: ToastData }) {
			return { ...state, show: true, data: action.payload };
		},
		hideToast(state) {
			return { ...state, show: false };
		},
	},
});

export const { showToast, hideToast } = toastSlice.actions;
export default toastSlice;
